export default "__VITE_ASSET__112b20b6__"